import { styled } from 'shared/Houston';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.xxl};

  p:nth-child(2) {
    color: ${({ theme }) => theme.neutralColor.low.medium};
    margin-bottom: ${({ theme }) => theme.spacing.sm};
  }
`;
